export const villes2 = [
  {
    slug: "couvreur-villiers-sur-marne",
    ville: "Villiers-sur-Marne",
    footerLabel: "Couvreur Villiers-sur-Marne",
    metaTitle: "Couvreur Villiers-sur-Marne — MSC Toitures | Réparation & réfection de toiture",
    metaDescription:
      "MSC Toitures, couvreur à Villiers-sur-Marne (94350) : réparation de toiture, fuite, réfection, gouttières, démoussage. Devis gratuit depuis Champigny.",
    h1: "Couvreur à Villiers-sur-Marne — MSC Toitures",
    intro: [
      "Villiers-sur-Marne est une commune résidentielle où les pavillons des années 1970 à 1990 côtoient des maisons plus anciennes. Beaucoup de ces toitures en tuiles mécaniques abordent aujourd'hui le cap où l'entretien ne suffit plus et où la question de la rénovation se pose.",
      "MSC Toitures intervient sur toute la commune, depuis son showroom de Champigny-sur-Marne tout proche : réparation, fuite, rénovation et réfection, zinguerie, entretien. Déplacement et devis gratuits.",
    ],
    blocks: [
      {
        h2: "Réparation de toiture à Villiers-sur-Marne",
        paragraphs: [
          "Sur les couvertures en tuiles mécaniques de la commune, les désordres typiques sont connus : tuiles qui se fissurent avec le gel, crochets fatigués, faitage qui se descelle. Nous réparons précisément, avec des tuiles à l'identique lorsque c'est possible.",
        ],
      },
      {
        h2: "Recherche et réparation de fuite",
        paragraphs: [
          "Une fuite sur un pavillon villiersois passe souvent par la sous-toiture vieillissante autant que par la couverture elle-même. Nous inspectons les deux — combles et toiture — pour réparer à la source et éviter les rechutes.",
        ],
      },
      {
        h2: "Rénovation et réfection de toiture",
        paragraphs: [
          "Quand une couverture de tuiles mécaniques atteint la fin de sa vie, la réfection permet de repartir sur des bases neuves : écran de sous-toiture, liteaux, couverture. C'est aussi l'occasion de vérifier la charpente et d'améliorer la ventilation de la toiture.",
        ],
      },
      {
        h2: "Zinguerie et gouttières",
        paragraphs: [
          "Gouttières pendantes en PVC ou en zinc, descentes, noues : nous réparons et remplaçons l'évacuation des eaux pluviales des pavillons de la commune, avec des pentes correctes et des fixations durables.",
        ],
      },
      {
        h2: "Entretien et démoussage",
        paragraphs: [
          "Les jardins arborés de Villiers-sur-Marne déposent feuilles et mousses sur les toits. Un entretien régulier — démoussage adapté, gouttières dégagées, contrôle des points sensibles — préserve votre couverture pour longtemps.",
        ],
      },
    ],
    whyPoints: [
      "Champigny-sur-Marne et Villiers-sur-Marne sont limitrophes : nous sommes vos voisins",
      "Déplacement et devis gratuits sur toute la commune",
      "Réparation, rénovation et réfection par une même équipe",
      "Conseils francs sur l'état réel de votre toiture",
    ],
    faq: [
      {
        q: "Ma toiture en tuiles mécaniques date des années 1980, faut-il la refaire ?",
        a: "Pas forcément : tout dépend de l'état réel des tuiles et des liteaux. Lors du diagnostic gratuit, nous vérifions la porosité des tuiles et l'état de la sous-toiture, puis nous vous disons si l'entretien suffit, si une rénovation est judicieuse, ou si la réfection s'impose.",
      },
      {
        q: "Remplacez-vous les gouttières en PVC ?",
        a: "Oui, nous réparons et remplaçons les gouttières en PVC comme en zinc, en adaptant le profil et la section à la surface de votre toiture.",
      },
    ],
    photo: "/photos/refection-termine.webp",
    photoAlt: "Toiture en tuiles rénovée par MSC Toitures à Villiers-sur-Marne et dans le 94",
  },
  {
    slug: "couvreur-bry-sur-marne",
    ville: "Bry-sur-Marne",
    footerLabel: "Couvreur Bry-sur-Marne",
    metaTitle: "Couvreur Bry-sur-Marne — MSC Toitures | Toiture, zinguerie & rénovation",
    metaDescription:
      "MSC Toitures, couvreur à Bry-sur-Marne (94360) : réparation de toiture, recherche de fuite, zinguerie, gouttières, rénovation. Déplacement et devis gratuits.",
    h1: "Couvreur à Bry-sur-Marne — MSC Toitures",
    intro: [
      "Bry-sur-Marne est une ville dense, où les petits pavillons serrés les uns contre les autres alternent avec les immeubles. Cette densité crée des configurations de toiture particulières : mitoyennetés, chéneaux encaissés, noues entre bâtiments — autant de points sensibles pour l'étanchéité.",
      "MSC Toitures intervient sur toute la commune depuis Champigny-sur-Marne : réparation, recherche de fuite, rénovation, zinguerie et entretien. Déplacement et devis gratuits.",
    ],
    blocks: [
      {
        h2: "Réparation de toiture à Bry-sur-Marne",
        paragraphs: [
          "Sur les toitures de Bry, l'accès et la mitoyenneté demandent un soin particulier. Nous réparons tuiles, ardoises, rives et faitages en tenant compte des contraintes de chaque maison, dans le respect du voisinage.",
        ],
      },
      {
        h2: "Recherche et réparation de fuite",
        paragraphs: [
          "Entre deux mitoyennetés, une infiltration peut venir de votre toit... ou du raccord avec celui du voisin. Notre recherche de fuite examine l'ensemble des zones de jonction — chéneaux, noues, relevés contre murs — pour identifier le vrai point d'entrée de l'eau.",
        ],
      },
      {
        h2: "Rénovation et réfection de toiture",
        paragraphs: [
          "Les petites couvertures des pavillons briards se rénovent ou se refont avec des chantiers compacts et bien organisés. Nous vous présentons un devis clair, poste par poste, après un diagnostic gratuit sur place.",
        ],
      },
      {
        h2: "Zinguerie et gouttières",
        paragraphs: [
          "Chéneaux encaissés et gouttières entre mitoyens sont la spécialité des villes denses comme Bry : nous les inspectons, les réparons et les refaçonnons pour que l'eau ne s'infiltre ni chez vous ni chez le voisin.",
        ],
      },
      {
        h2: "Entretien et démoussage",
        paragraphs: [
          "Peu exposées au vent, les toitures des quartiers denses s'encrassent vite. Un démoussage et un curage régulier des gouttières évitent la plupart des désordres d'humidité.",
        ],
      },
    ],
    whyPoints: [
      "Expérience des toitures en mitoyenneté et des chéneaux encaissés",
      "Déplacement et devis gratuits sur Bry-sur-Marne",
      "Entreprise locale, showroom à Champigny-sur-Marne",
      "Intervention propre et organisée, même sur les petites cours",
    ],
    faq: [
      {
        q: "La fuite semble venir de la jonction avec la toiture voisine, que faire ?",
        a: "C'est une situation classique en mitoyenneté. Nous examinons les chéneaux et raccords des deux côtés de la jonction pour identifier l'origine exacte, puis nous vous expliquons la réparation nécessaire.",
      },
      {
        q: "Intervenez-vous sur les petites toitures de pavillon ?",
        a: "Oui, bien sûr : réparation ponctuelle comme réfection complète, nous prenons en charge les toitures de toutes tailles à Bry-sur-Marne.",
      },
    ],
    photo: "/photos/refection.webp",
    photoAlt: "Chantier MSC Toitures avec échafaudage à Bry-sur-Marne et dans le Val-de-Marne",
  },
  {
    slug: "couvreur-chennevieres-sur-marne",
    ville: "Chennevières-sur-Marne",
    footerLabel: "Couvreur Chennevières-sur-Marne",
    metaTitle: "Couvreur Chennevières-sur-Marne — MSC Toitures | Toiture & rénovation 94",
    metaDescription:
      "MSC Toitures, couvreur à Chennevières-sur-Marne (94430) : réparation de toiture, fuite, rénovation, zinguerie, entretien. Déplacement et devis gratuits.",
    h1: "Couvreur à Chennevières-sur-Marne — MSC Toitures",
    intro: [
      "Chennevières-sur-Marne, entre le coteau et la boucle de la Marne, est une commune majoritairement pavillonnaire. Les toitures y vivent au rythme des arbres, des intempéries et du temps : tuiles qui vieillissent, mousses qui s'installent, gouttières qui se bouchent.",
      "Depuis Champigny-sur-Marne, juste en contrebas, MSC Toitures intervient dans tous les quartiers de Chennevières : réparation, fuite, rénovation, zinguerie et entretien. Déplacement et devis gratuits.",
    ],
    blocks: [
      {
        h2: "Réparation de toiture à Chennevières-sur-Marne",
        paragraphs: [
          "Tuile envolée après un coup de vent sur le coteau, faitage descellé, rive dégradée : nous intervenons sur tous les désordres courants des toitures chenneviéroises, avec un diagnostic gratuit avant tout chiffrage.",
        ],
      },
      {
        h2: "Recherche et réparation de fuite",
        paragraphs: [
          "Les combles des pavillons de Chennevières racontent souvent l'histoire d'une fuite avant même que nous montions sur le toit. Nous remontons la trace de l'eau jusqu'à son origine — tuile, noue, abergement — et nous réparons durablement.",
        ],
      },
      {
        h2: "Rénovation et réfection de toiture",
        paragraphs: [
          "Quand une couverture vieillit uniformément, la rénovation ou la réfection redonne à la maison une protection complète. Nous vous présentons les options avec un devis détaillé et gratuit, sans pression commerciale.",
        ],
      },
      {
        h2: "Zinguerie et gouttières",
        paragraphs: [
          "Gouttières pendantes, descentes, noues et chéneaux : nous remettons en état l'évacuation des eaux pluviales pour préserver façades et fondations, avec des éléments adaptés à votre toiture.",
        ],
      },
      {
        h2: "Entretien et démoussage",
        paragraphs: [
          "Entre la Marne et les espaces verts, les toitures de Chennevières apprécient un entretien régulier : démoussage adapté, curage des gouttières, contrôle des points singuliers. Un petit entretien vaut mieux qu'une grosse réparation.",
        ],
      },
    ],
    whyPoints: [
      "Chennevières touche Champigny-sur-Marne : nous sommes à quelques minutes",
      "Déplacement et devis gratuits sur toute la commune",
      "Tous les travaux de toiture par une même entreprise",
      "Devis détaillé, sans engagement",
    ],
    faq: [
      {
        q: "Intervenez-vous dans les quartiers en hauteur de Chennevières ?",
        a: "Oui, nous intervenons dans tous les quartiers de la commune, du bord de Marne au plateau. L'accès à la toiture fait partie des points que nous vérifions lors du déplacement gratuit.",
      },
      {
        q: "Combien coûte une réparation de toiture ?",
        a: "Cela dépend du désordre : remplacer quelques tuiles n'a rien à voir avec reprendre une noue. C'est exactement pour cela que le déplacement et le devis sont gratuits — vous savez ce qui est nécessaire avant de décider.",
      },
    ],
    photo: "/photos/equipe.webp",
    photoAlt: "Couvreur MSC Toitures en intervention à Chennevières-sur-Marne",
  },
  {
    slug: "couvreur-le-plessis-trevise",
    ville: "Le Plessis-Trévise",
    footerLabel: "Couvreur Le Plessis-Trévise",
    metaTitle: "Couvreur Le Plessis-Trévise — MSC Toitures | Toiture, fuite & entretien 94",
    metaDescription:
      "MSC Toitures, couvreur au Plessis-Trévise (94420) : réparation de toiture, recherche de fuite, rénovation, gouttières, démoussage. Devis gratuit.",
    h1: "Couvreur au Plessis-Trévise — MSC Toitures",
    intro: [
      "Le Plessis-Trévise est une commune calme et résidentielle, faite de pavillons entourés de jardins. Des toitures de tuiles mécaniques pour l'essentiel, exposées aux mousses des jardins arborés et aux feuilles qui bouchent les gouttières chaque automne.",
      "MSC Toitures intervient sur toute la commune depuis Champigny-sur-Marne : réparation, recherche de fuite, rénovation, zinguerie et entretien. Déplacement et devis gratuits.",
    ],
    blocks: [
      {
        h2: "Réparation de toiture au Plessis-Trévise",
        paragraphs: [
          "Sur les pavillons plesséens, la plupart des réparations tiennent en peu de choses : quelques tuiles à remplacer, un faitage à ressceller, une rive à consolider. Nous réparons ce qui doit l'être — et seulement cela.",
        ],
      },
      {
        h2: "Recherche et réparation de fuite",
        paragraphs: [
          "Une infiltration ne pardonne pas : mieux vaut la faire localiser tôt. Nous inspectons couverture, combles et points singuliers pour trouver l'origine exacte de l'eau, puis nous réparons à la source.",
        ],
      },
      {
        h2: "Rénovation et réfection de toiture",
        paragraphs: [
          "Les pavillons des années 1970-1990 arrivent pour beaucoup à l'âge où la couverture demande une vraie remise à neuf. Nous évaluons honnêtement l'état de la vôtre et chiffrons la solution adaptée : rénovation ciblée ou réfection.",
        ],
      },
      {
        h2: "Zinguerie et gouttières",
        paragraphs: [
          "Les gouttières des pavillons plesséens récoltent feuilles et mousses des jardins environnants. Curage, réparation de joints, remplacement de sections : nous gardons votre évacuation des eaux en pleine forme.",
        ],
      },
      {
        h2: "Entretien et démoussage",
        paragraphs: [
          "Un démoussage adapté et un contrôle régulier sont particulièrement utiles sur les toitures entourées d'arbres. Nous vous indiquons franchement ce qui est nécessaire, et ce qui peut attendre.",
        ],
      },
    ],
    whyPoints: [
      "Entreprise de couverture locale, basée dans le Val-de-Marne",
      "Déplacement et devis gratuits au Plessis-Trévise",
      "Contact direct avec votre couvreur, au 06 46 30 03 91",
      "Travail soigné et conseils personnalisés",
    ],
    faq: [
      {
        q: "Les feuilles de mes arbres bouchent mes gouttières chaque automne, que faire ?",
        a: "C'est le lot des pavillons arborés du Plessis-Trévise. Un curage régulier suffit le plus souvent ; nous vérifions au passage la pente, les joints et les descentes pour éviter les débordements qui tachent les façades.",
      },
      {
        q: "Faites-vous les petits travaux de toiture ?",
        a: "Oui : remplacer quelques tuiles, ressceller un faitage ou réparer une descente de gouttière fait partie de nos interventions courantes. Le déplacement et le devis restent gratuits.",
      },
    ],
    photo: "/photos/refection-pendant.webp",
    photoAlt: "Réfection de toiture en cours par MSC Toitures au Plessis-Trévise et dans le 94",
  },
];
